<template>
  <div>
    <div id="payment-container">

      <div @click="selectPayByCard(1)" class="p-3 border border-2 border-dark d-flex flex-row col-lg-8" style="border-radius: 1rem; border-width: 2px; border-color: black">
        <div style="margin-top: -1.2rem">
          <div  class="new-custom-checkbox mt-4 mr-1" :class="selectedPaymentMethod ===1 && 'bg-black'"></div>
        </div>

      <div class="w-100">
        <div class="card-input" id="card-element"></div>

        <div v-if="error" style="paddingTop: 8px; color: red; font-size: 12px" id="card-error">
          {{error}}
        </div>

      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import {mapActions, mapGetters} from "vuex";
import {AppConfig} from "../../../AppConfig";
export default {
  name: "card-component",
  directives: {mask},
  props: {
    editModel: {
      type: Object,
      default: () => {
      }
    },
    Title: {
      type: String,
      default: () => ""
    },
    isUserProfile: {
      type: Boolean,
      default: false
    },
    selectedPaymentMethod : {
      type : Number
    }
  },
  data() {
    return {
      cardType: "master",
      stripe: null,
      clientSecret: "",
      token: null,
      cardElement: null,
      error: ''
    };
  },
  computed: {
    AppConfig() {
      return AppConfig
    },
    ...mapGetters(["viewConfig", "getStripeKey"]),
    showNewUi(){
      return this.viewConfig.IsNewUi;
    },
    stripeElements () {
      return this.$stripe.elements();
    },

  },
  mounted() {

    this.cardElement = this.stripeElements.create('card', {
      hidePostalCode: true
    });

    this.cardElement.mount('#card-element');

    this.cardElement.on('focus', ()  =>{
      if(this.selectedPaymentMethod === 1) return
      this.selectPayByCard(1)
    });

  },
  methods: {
    ...mapActions(["setCardNumber", "clearCardType"]),
    clearError(){
      this.error=""
    },
    async validate() {
      const { token, error } = await this.$stripe.createToken(this.cardElement);
      if(error){
        this.error = error.message
        return
      }
    this.$emit('setPaymentMethod', 1)
    return !!token
    },
    selectPayByCard(checked) {
      this.clearError()
      this.$emit('setPaymentMethod', Number(checked) || null)
    },
    getCardElement() {
      return this.cardElement
    },
  }
};
</script>
<style lang="scss" scoped>
.card-vaidation {
  .invalid-feedback {
    display: block;
  }
}

 .cardImg{
   width: 27px;
   height: 20px;
   margin-right: 4px;
 }

 .card-input {
   padding: 10px;
   width: 100%;
   border: 1px solid #ced4da;
 }

</style>
